import request from "@/CommonDP/utils/request";
import { getToken, getContextPath } from "@/CommonDP/mongeView/utils";
import { getShareToken } from "@/CommonDP/mongeView/utils/share";
import { isDef } from "@/CommonDP/utils/common";
import globalParams from "@/CommonDP/utils/globalParams.js";
export default {
  revertChanges(fileId) {
    return request.post(`/wopi/files/onlyoffice/revertChanges?fileId=xxx${fileId}`).then((res) => res);
  },
  finishDesign(data) {
    return request.post(`/flowNew/printTemplate/onlineTemplateCompleteEdit`, data).then((res) => res);
  },
  // 设计打印用整体上传
  designPrintManualUpload(flowDefinitionId, params) {
    return request.post(`/flowNew/printTemplate/upload?flowDefinitionId=${flowDefinitionId}`, params);
  },
  // 设计打印用 删除
  delDesignPrintFile(fileId, flowDefinitionId) {
    return request.post(`/flowNew/printTemplate/delete?fileId=${fileId}&flowDefinitionId=${flowDefinitionId}`);
  },
  saveTemplate(data) {
    return request.post(`/wopi/files/onlyoffice/formTemplateSave`, data).then((res) => res);
  },
  getFileDetails(fileId, i) {
    const id = encodeURIComponent(i);
    if (getToken()) {
      return request.get(`file/getFileDetails?fileId=${fileId}`).then((res) => res);
    } else {
      return request.get(`/doc/shareNew/file/detail?fileId=${fileId}&id=${id}`).then((res) => res);
    }
  },
  queryDwgSpace(fileID, fileVersion) {
    if (getToken()) {
      return request.get(`/doc/query-dwg/web-converts-info?fileId=${fileID}&fileVersion=${fileVersion}`).then((res) => res);
    } else {
      return request.get(`/doc/shareNew/query-dwg/web-converts-info?fileId=${fileID}&fileVersion=${fileVersion}`).then((res) => res);
    }
  },
  queryModelUrlList(rvtId, rvtVersion) {
    var a = decodeURIComponent(rvtId);
    var rvtIds = encodeURIComponent(a);
    if (getToken()) {
      return request.get(`/doc/unzip-file/list-filePath?fileId=${rvtIds}&fileVersion=${rvtVersion}`).then((res) => res);
    } else {
      return request.get(`/doc/share/unzip-file/list-filePath?fileId=${rvtIds}&fileVersion=${rvtVersion}`).then((res) => res);
    }
  },
  queryDwgList(fileId, rvtVersion) {
    if (getToken()) {
      return request.get(`/doc/model/query-model-paper-infos?fileId=${fileId}&fileVersion=${rvtVersion}`).then((res) => res);
    } else {
      return request.get(`/doc/share/model/query-model-paper-infos?fileId=${fileId}&fileVersion=${rvtVersion}`).then((res) => res);
    }
  },
  queryDetail(fileId) {
    return request.post(`/doc/queryDetail?id=${fileId}&isFolder=0&versionID=`).then((res) => res);
  },
  queryTree(data = {}) {
    // 自定义接口地址
    const newUrl = globalParams.get("url:/doc/list");
    if (isDef(newUrl)) {
      return request.post(`${newUrl}`, data);
    }
    return request.post("/doc/list", data).then((res) => res);
  },
  personalDocTree(data = {}) {
    return request.post("/personal/doc/list", data).then((res) => res);
  },
  enterpriseDocTree(data = {}) {
    return request.post("/enterprise/doc/list", data).then((res) => res);
  },
  enterpriseDeptDocTree(data = {}) {
    return request.post("/enterpriseDept/doc/list", data).then((res) => res);
  },
  async queryConvertMode(fileId, fileVersion) {
    if (getToken()) {
      return request.get(`/light/file/convertMode?fileId=${fileId}&fileVersion=${fileVersion}`);
    } else {
      const shareToken = await getShareToken();
      return request.get(`/doc/shareNew/light/file/convertMode?fileId=${fileId}&version=${fileVersion}&shareToken=${shareToken}`);
    }
  },

  async queryModelLightFilesFromMLib(fileId, rvtVersion) {
    const rvtIds = encodeURIComponent(decodeURIComponent(fileId));
    if (getToken()) {
      return request.get(`/light/file/list?fileId=${rvtIds}&fileVersion=${rvtVersion}`);
    } else {
      const shareToken = await getShareToken();
      return request.get(`/doc/shareNew/light/file/list?fileId=${rvtIds}&version=${rvtVersion}&shareToken=${shareToken}`);
    }
  },
  async getoffice(fileId, fileVersion) {
    if (getToken()) {
      return request.get(`/wopi/getWopiClientUri?fileId=${fileId}&version=${fileVersion}&isEdit=false`).then((res) => res);
    } else {
      const shareToken = await getShareToken();
      return request.get(`/doc/shareNew/office/getPreviewUrl?fileId=${fileId}&version=${fileVersion}&shareToken=${shareToken}&isEdit=false`).then((res) => res);
    }
  },
  async getonlyoffice(fileId, fileVersion) {
    return request.get(`/wopi/files/getOnlyOfficeClientUri?fileId=${fileId}&version=${fileVersion}&isEdit=false`);
  },
  // 打印设计用
  async getonlyoffice2(fileId, fileVersion) {
    return request.get(`/flowNew/printTemplate/getUri?fileId=${fileId}&version=${fileVersion}&isEdit=false`);
  },
  // 打印设计用
  async getDesignFormField(flowVersionId, flowDefinitionId, flowKey) {
    return request.get(`/dyn-form-design/getPrintTemplate?flowVersionId=${flowVersionId}&flowDefinitionId=${flowDefinitionId}&flowKey=${flowKey}`);
  },
  async getofficeViewType() {
    return request.get("/wopi/files/getOfficeViewType");
  },
  async onlyOfficeCancel(fileId) {
    return request.post(`/wopi/files/onlyoffice/revertChanges?fileId=${fileId}`);
  },
  async onlyOfficeSave(params) {
    return request.post("/wopi/files/onlyoffice/completeEdit", params);
  },
  async noLightweightUrl(prjId, fileId, version) {
    if (getToken()) {
      // 自定义接口地址
      const newUrl = globalParams.get("url:/doc/download/${prjId}/${fileId}");
      if (isDef(newUrl)) {
        return location.origin + getContextPath() + `${newUrl}/${prjId}/${fileId}?version=${version || ""}&token=${getToken()}`;
      }
      return location.origin + getContextPath() + `/doc/download/${prjId}/${fileId}?version=${version || ""}&token=${getToken()}`;
    } else {
      const shareToken = await getShareToken();
      return location.origin + getContextPath() + `/doc/shareNew/file/download?fileId=${fileId}&version=${version}&shareToken=${shareToken}`;
    }
  },
  // 添加到最近文档
  recentViewRecordAdd(fileId, fileVersion) {
    if (getToken()) {
      return request.get(`/recentViewRecord/add?fileId=${fileId}&fileVersion=${fileVersion}`).then((res) => res);
    } else {
      return "";
    }
  },
  // 4
  getDrawingQuestionDetails(questionId, userId, flowInstanceId, shareId) {
    if (!globalParams.get("isHky")) {
      return request.get(`/drawing-annotation/getById?id=${questionId}&userId=${userId}&flowInstanceId=${flowInstanceId || ""}&shareId=${shareId || ""}`);
    } else {
      return request.get(`${globalParams.get("queryQuestionDetailsReq")}?id=${questionId}&userId=${userId}`);
    }
  },
  // 叠图查询
  overlaySearch(id) {
    return request.get(`/bim/stack/query-list?fileOrFolderId=${id}`).then((res) => res);
  },
  // 叠图新增
  overlayAdd(params) {
    return request.post("/bim/stack/save", params).then((res) => res);
  },
  // 叠图删除
  overlayDel(params) {
    return request.get(`/bim/stack/delete`, { params }).then((res) => res);
  },
  getNotationDic(prjID, fileId, userId) {
    if (!globalParams.get("isHky")) {
      return request.get(`/drawing-annotation/dicList?prjId=${prjID}&fileId=${fileId}&userId=${userId}`);
    } else {
      return request.get(`${globalParams.get("queryNotationDicReq")}?prjId=${prjID}&fileId=${fileId}&userId=${userId}`);
    }
  },
  notationEdit(data) {
    return request.post("/lc/drawing-annotation/update", data);
  },
  picupload(params) {
    return request.post("/pic/upload", params).then((res) => res);
  },
  prjPersonPlanQueryUserListRole(data) {
    return request.post("/prj-person-plan/query-user-list/role", data).then((res) => res);
  },
  getDicList(params) {
    if (!globalParams.get("isHky")) {
      return request.get(`/drawing-annotation/dicList`, { params: params });
    } else {
      return request.get(`${globalParams.get("queryNotationDicReq")}`, { params: params });
    }
  },
  notationAdd(params) {
    return request.post("/drawing-annotation/add", params).then((res) => res);
  },
  getFilterDic(prjId, userId, flowInstanceId) {
    if (!globalParams.get("isHky")) {
      return request.get(`/drawing-annotation/getFilterConditions?prjId=${prjId}&userId=${userId}&flowInstanceId=${flowInstanceId || ""}`);
    } else {
      return request.get(`${globalParams.get("queryFilterDicReq")}?prjId=${prjId}&userId=${userId}`);
    }
  },
  notationlist(params) {
    if (globalParams.get("isHky")) {
      return request.post(`${globalParams.get("queryNotationlistReq")}`, params);
    }
    // 自定义接口地址
    const newUrl = globalParams.get("url:/drawing-annotation/list");
    if (isDef(newUrl)) {
      return request.post(`${newUrl}`, params);
    }
    return request.post(`/drawing-annotation/list`, params);
  },
  drawingDrawingQuesExport(params) {
    return request({
      responseType: "blob",
      url: "/drawing-annotation/export",
      method: "post",
      data: params
    });
  },
  // 导出OA贯标表格
  exportOA(params) {
    return request({
      responseType: "blob",
      url: "/drawing-annotation/exportOA",
      method: "post",
      data: params
    });
  },
  drawingQuestionDelete(ids) {
    return request.post(`/drawing-annotation/delete`, ids).then((res) => res);
  },
  drawingannotationupdateStatus(data) {
    return request.post("/drawing-annotation/updateStatus", data).then((res) => res);
  },
  recallComment(commentId) {
    return request.get(`/comment/delete/${commentId}`).then((res) => res);
  },
  getCommentList(relaId, prjId) {
    return request.get(`/comment/list?relaId=${relaId}&prjId=${prjId}`).then((res) => res);
  },
  getUserInfoListByPrjId(prjId, userId) {
    return request.get(`/project/getProjectUsers?projectId=${prjId}&userId=${userId}`).then((res) => res);
  },
  createComment(data) {
    // 自定义接口地址
    const newUrl = globalParams.get("url:/comment/add");
    if (isDef(newUrl)) {
      return request.post(`${newUrl}`, data);
    }
    return request.post("/comment/add", data);
  },
  getDrawingQuestionRecord(id, userId, flowInstanceId, sharerId) {
    return request
      .get(`/drawing-annotation/getStatusUpdateRecordList?id=${id}&userId=${userId}&flowInstanceId=${flowInstanceId || ""}&sharerId=${sharerId || ""}`)
      .then((res) => res);
  },
  queryHlsUrl(fileId) {
    if (getToken()) {
      return request.get(`/file/getMp4HlsUrl?fileId=${fileId}`).then((res) => res);
    } else {
      return request.get(`/wopi/files/getMp4HlsUrl?fileId=${fileId}`).then((res) => res);
    }
  },
  // 批注截图上传接口（新）
  picUploadNew(params) {
    return request.post("/pic/newUpload", params);
  },
  getUserPrjRole(prjId) {
    return request.get(`/prj-person-plan/getUserPrjRole?prjId=${prjId}`).then((res) => res);
  }
};
